import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class FormSection extends React.Component {
    state = {
    }


    componentDidMount() {
        this.changeValue(this.props.header.information?.tabs[0].key)
    }

    changeValue(key) {
        this.props.changeValue(key)

    }


    render() {
        return (
            <div className="w-100 h-100 ">
                <div className="flexc w-100 p-2 px-3" style={{ overflow: 'auto', }}>
                    {this.props.header.information?.tabs?.map((tab, index) => {
                        return (
                            <p key={index} onClick={() => this.changeValue(tab.key)} className="py-2 mrd-2 cursor-poiner text-center weight-500 font-size-14 px-2" style={{ color: this.props.data == tab.key ? '#007aff' : '#777', borderBottom: this.props.data == tab.key ? '2px solid #007aff' : '2px solid transparent' }}>
                                {checkTranslation(tab.label)}
                            </p>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default FormSection;